export const searchType = {
  PostalCode: "0",
  Location: "1",
};
